import { Injectable } from '@angular/core';
import { TranslocoService } from "@ngneat/transloco";
import { ConfirmationService, MessageService } from "primeng/api";

@Injectable({
  providedIn: 'root'
})
export class CommonMessagesService {

  constructor(private i18n: TranslocoService,
              private confirmationService: ConfirmationService,
              private messageService: MessageService) {}

  public showChangesSavedMessage() {
    let summary = this.i18n.translate('success.generic.changesApplied');
    let detail = this.i18n.translate('success.save.saved');
    this.messageService.add({severity: 'success', summary: summary, detail: detail, sticky: false});
  }

  public showErrorWhileSavingChangesMessage() {
    let summary = this.i18n.translate('error.summary.unexpected');
    let detail = this.i18n.translate('error.delete.unexpected');
    this.messageService.add({severity: 'error', summary: summary, detail: detail, sticky: true});
  }

  public showRestoreDefaultsConfirmation(acceptCallback) {
    this.confirmationService.confirm({
      icon: 'pi pi-exclamation-triangle',
      message: this.i18n.translate("info.confirmRestoreDefaults"),
      header: this.i18n.translate("forms.confirmation"),
      acceptLabel: this.i18n.translate("common.accept"),
      rejectLabel: this.i18n.translate("common.cancel"),
      acceptIcon: 'pi pi-check',
      defaultFocus: 'none',
      acceptButtonStyleClass: 'p-button-text',
      accept: acceptCallback
    });
  }

}
